import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { LightBulbIcon } from '@heroicons/react/24/outline';

export default function TipsModal({ tips, phaseName }) {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => setIsOpen(false);
  const openModal = () => setIsOpen(true);

  return (
    <>
      {/* Light Bulb Icon */}
      <LightBulbIcon
        className="w-5 h-5 text-gray-500 hover:text-gray-700 cursor-pointer"
        onClick={openModal}
      />
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 z-[1050]" onClose={closeModal}>
          {/* Full-page shadow */}
          <div className="fixed inset-0 bg-black bg-opacity-50 z-[1049]" aria-hidden="true" />

          <div className="fixed inset-0 overflow-y-auto z-[1050]">
            <div className="flex items-center justify-center min-h-screen py-4 px-2 sm:px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Tips for "{phaseName || 'this phase'}"
                  </Dialog.Title>
                  {/* Scrollable content */}
                  <div className="mt-4 max-h-96 overflow-y-auto">
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                      {tips.length > 0 ? (
                        tips.map((tip, index) => (
                          <li key={index}>{tip}</li>
                        ))
                      ) : (
                        <p className="text-gray-500">No tips provided for this phase.</p>
                      )}
                    </ul>
                  </div>
                  <div className="mt-6 flex justify-end">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-lg border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
